import { useTranslation } from 'next-i18next'

import { OperatorSignType } from '../types'

import Equation from './Equation'
const textClassName = 'font-semibold inline-block text-2xl'

interface Operator {
  onClick?: () => void
  isWrong?: boolean
}

export const Multiplication = ({ onClick, isWrong }: Operator): React.ReactElement => (
  <span
    className={`${textClassName} px-1 ${onClick && 'cursor-pointer'} ${isWrong ? 'text-red' : 'text-purple'}`}
    onClick={onClick}
  >
    ×
  </span>
)
export const Subtraction = ({ onClick, isWrong }: Operator): React.ReactElement => (
  <span
    className={`${textClassName} px-1 ${onClick && 'cursor-pointer'} ${isWrong ? 'text-red' : 'text-purple'}`}
    onClick={onClick}
  >
    -
  </span>
)
export const Addition = ({ onClick, isWrong }: Operator): React.ReactElement => (
  <span
    className={`${textClassName} px-1 ${onClick && 'cursor-pointer'} ${isWrong ? 'text-red' : 'text-purple'}`}
    onClick={onClick}
  >
    +
  </span>
)
export const Division = ({ onClick, isWrong }: Operator): React.ReactElement => {
  const { t } = useTranslation('bootcamp')

  return (
    <span
      className={`${textClassName} px-1 ${onClick && 'cursor-pointer'} ${isWrong ? 'text-red' : 'text-purple'}`}
      onClick={onClick}
    >
      {t('signs.division')}
    </span>
  )
}
export const Power = ({
  value,
  onClick,
  isWrong,
}: Operator & {
  value: number | string
}): React.ReactElement => (
  <span className={`${textClassName} relative w-2 h-7 inline-block`}>
    <span
      className={`text-xs leading-4 absolute -top-1.5 ${onClick && 'cursor-pointer'} ${
        isWrong ? 'text-red-medium' : 'text-purple'
      }`}
      onClick={onClick}
    >
      {value}
    </span>
  </span>
)
export const SquareRoot = ({
  eq,
  onClick,
  onEqOperatorClick,
  indexInEquation,
  isWrong,
}: Operator & {
  eq: string
  onEqOperatorClick?: (indexInEquation: number, type: OperatorSignType) => void
  indexInEquation: number
}): React.ReactElement => {
  const bgColorClass = isWrong ? 'bg-[#EF524F]' : 'bg-[#8F4FD6]'

  return (
    <div
      className={`flex items-center relative before:h-0 before:absolute before:left-5 before:right-0 before:top-0 before:border ${
        isWrong ? 'before:border-red-medium' : 'before:border-purple'
      } pr-0.5`}
    >
      <div className={`flex items-end px-2 overflow-hidden ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
        <u className={`h-5 w-0.5 ${bgColorClass} transform rotate-[325deg] relative -bottom-0.5 pointer-events-none`} />
        <u className={`h-7.5 w-0.5 ${bgColorClass} transform rotate-[10deg] ml-1.5 pointer-events-none`} />
      </div>
      <Equation
        addWithIndex={indexInEquation + 5}
        isWrong={isWrong}
        onOperatorClick={onEqOperatorClick}
        statement={eq}
      />
    </div>
  )
}

export const Digit = ({ value }: { value: number | string }): React.ReactElement => (
  <span className={textClassName}>{value}</span>
)

interface ParenthesisEqProps {
  indexInEquation: number
  isWrong?: boolean
  onEqOperatorClick?: (indexInEquation: number, type: OperatorSignType) => void
  eq: string
}

export const ParenthesisEquation = ({
  indexInEquation,
  isWrong,
  onEqOperatorClick,
  eq,
}: ParenthesisEqProps): React.ReactElement => (
  <div className="flex items-center">
    <span className={`${textClassName} px-1`}>(</span>
    <Equation addWithIndex={indexInEquation + 1} isWrong={isWrong} onOperatorClick={onEqOperatorClick} statement={eq} />
    <span className={`${textClassName} px-1`}>)</span>
  </div>
)
